import React, { memo } from 'react'
import Navbar from '../Navbar'
import BigText from './BigText'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/homepage.styles'
import Menu from '../Menu'
import Sidebar from '../Sidebar/Sidebar'
import VisibilitySensor from '../VisibilitySensor'
import { useAppSelector } from '../app/hooks'
import clsx from 'clsx'
import arrow from './assets/images/arrow.svg'
import { useMediaQuery } from '@material-ui/core'
import { HomePageConfig } from '../../configuration'
import { IspirazionePageConfig } from '../../configuration'
import AssignId from '../AssignId'

const useStyles = makeStyles(styles)

function Homepage() {
    const isMobile = useMediaQuery('(max-width: 760px)')
    const classes = useStyles()
    const sideBarVisible = useAppSelector(state => state.pageIndex.sideBarVisible)
    return (
        <div className={classes.bg} >
            <AssignId
                id={HomePageConfig.slug}
                absolute
                y={0}
                yMobile={0}
            />
            <video className={classes.video} autoPlay playsInline muted >
                {isMobile ? <source src={HomePageConfig.videoUrlMobile}/> : <source src={HomePageConfig.videoUrl} /> }
            </video>
            <Sidebar elements={HomePageConfig.navElements} visible={sideBarVisible} />
            <Menu list={HomePageConfig.navElements} />
            <Navbar btnBackground={'#0045EA'} btnColor={'white'} />
            <div className={classes.root} >
                <BigText primaryText={HomePageConfig.title} textColor='white' secondaryText={HomePageConfig.secondary} />
            </div>
            <VisibilitySensor index={0} />
            <span id='0' className={classes.span} >
                <div className={classes.wrapper} >
                    <a href={IspirazionePageConfig.id} className={classes.p} >{IspirazionePageConfig.title}</a>
                    <a href={IspirazionePageConfig.id}><img className={clsx(classes.arrow, 'scrollArrow')} alt='arrow-down' src={arrow} /></a>
                </div>
                <div className={classes.fade} ></div>
            </span>
        </div>
    )
}

export default memo(Homepage)
